const homeBannerSlider = new Swiper(".home__banner__slider", {
  pagination: {
    el: ".home__banner__slider .swiper-pagination",
    clickable: !0,
    renderBullet: (e, n) => '<span class="' + n + '">0' + (e + 1) + "</span>",
  },
  effect: "fade",
  autoplay: { delay: 4e3, disableOnInteraction: !1 },
});
